import React, {useContext} from 'react'
import {DialogContext} from '../../context/Dialog'
import DialogAlert from './DialogAlert'
import DialogYesNoCancel from './DialogYesNoCancel'
import DialogYesNo from './DialogYesNo'

function ReservationDialog() {
  const {dialogs, handleExited, handleClose} = useContext(DialogContext)

  return dialogs.map((d, i) => {
    switch (d.dialogType) {
      case 'yes-no-cancel':
        return (
          <DialogYesNoCancel
            index={i}
            key={i}
            open={d.open}
            {...d.data}
            onClose={e => handleClose(e, i)}
          />
        )
      case 'alert':
        return (
          <DialogAlert
            index={i}
            key={i}
            open={d.open}
            {...d.data}
            onClose={e => handleClose(e, i)}
          />
        )
      case 'yes-no':
        return (
          <DialogYesNo
            index={i}
            key={i}
            open={d.open}
            {...d.data}
            onClose={e => handleClose(e, i)}
          />
        )
      default:
        return null
    }
  })
}

export default ReservationDialog
